<template>
    <div id="internal" class="btn btn_internal">
        <h3>
            <span class="btn-id hide_on_mobile">02</span>
            <span class="btn-content"><span class="hide_on_mobile">internal</span> structure</span>
        </h3>
    </div>
</template>